
import common from './es/common';
import home from './es/home';
import airports from './es/airports';
import profiles from './es/profiles';
import settings from './es/settings';
import reviews from './es/reviews';
import inventory from './es/inventory';
import auth from './es/auth';
import navigation from './es/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
